
// NOTE: Re-implementing this file and the below script as a stop gap solution supporting the soon to be replaced top of learn page.

import mainPublic from '../../core/main-public';

if (document.readyState === 'loading') {
  // The DOM is still loading, set up the event listener
  document.addEventListener("DOMContentLoaded", () => {
    mainPublic.init();
  });
} else {
  // The DOM has already loaded, initialize immediately
  mainPublic.init();
}
